import React, { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

interface AuthProviderProps {
    children: ReactNode;
}

const config = {
    domain: process.env.pnp-qa-eus2.us.auth0.com || '',
    clientId: process.env.vBmJ4H2L6EEzzjzjF2xqZK0dZDIfODEC || '',
    audience: process.env.https://pharma-navigator.com || '',
    connection: process.env.Username-Password-Authentication || '',
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    return (
        <Auth0Provider
            domain={config.domain}
            clientId={config.clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: config.audience,
                scope: 'openid profile email offline_access',
                connection: config.connection,
            }}
            useRefreshTokens={true}
            cacheLocation='localstorage'
        >
            {children}
        </Auth0Provider>
    );
};

export default AuthProvider;
